import { render } from "./NotificationSignup.vue?vue&type=template&id=1c5a756a"
import script from "./NotificationSignup.vue?vue&type=script&lang=js"
export * from "./NotificationSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__